// «عرض الكل»: عرض كل السجلات بقائمة واحدة بلا صفحات.
//
// السقف موجود لحماية المتصفح لا لتقييد المستخدم: الجداول هنا تُرسم كاملة في
// DOM، وعشرات الآلاف من الصفوف تُجمّد الجهاز. عند تجاوز السقف نعرض الأحدث
// ونقول للمستخدم صراحةً أن يضيّق الفلتر بدل أن نُخفي الباقي بصمت.
export const VIEW_ALL_LIMIT = 5000;

/** نص التنبيه عند تجاوز السقف، أو null إذا كانت النتائج كاملة. */
export function viewAllNotice(shown, total) {
  const n = Number(total) || 0;
  const s = Number(shown) || 0;
  if (!n || s >= n) return null;
  return `يُعرض أحدث ${s.toLocaleString('en-US')} من إجمالي ${n.toLocaleString('en-US')} سجل — ضيّق الفلتر لعرض الباقي.`;
}

/**
 * بارامترات الاستعلام حسب الوضع.
 * في وضع «عرض الكل» تُثبَّت الصفحة على 1 كي لا يعود الجدول للصفحات عند
 * تغيير أي فلتر (وهو ما طلبه العميل صراحةً).
 */
export function listParams({ all, page = 1, limit = 20 } = {}) {
  return all ? { page: 1, limit: VIEW_ALL_LIMIT } : { page, limit };
}
